export default __webpack_public_path__ + "static/media/LAS1000.34I-43774_-26143_0.c21ba680.jpg";